"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { usePublicMemberList } from "@/app/(main)/(club)/mes-clubs/[id]/hooks/use-members";
import { EmblaCarousel } from "@/app/(main)/_public_components/slider";
import ComponentLoading from "@/components/global/component-loading";
import Info from "@/components/user/info";
import useMobile from "@/hooks/use-mobile";
import { Club } from "@/TS/Interfaces/global_interfaces";
export default function MemberList(props) {
  const $ = _c(10);
  const {
    data: t0,
    isLoading
  } = usePublicMemberList(props.club.slug, true);
  const members = t0 === undefined ? [] : t0;
  const isMobile = useMobile();
  const slides = [];
  const slideSize = isMobile ? 3 : 6;
  for (let i = 0; i < members.length; i = i + slideSize, i) {
    const slideMembers = members.slice(i, i + slideSize);
    slides.push(slideMembers);
  }
  if (!isLoading && members.length === 0) {
    return null;
  }
  const t1 = "rounded ring-light-grey ring-2 p-4";
  const t2 = members.length > 0 && !isLoading ? `(${members.length})` : "";
  let t3;
  if ($[0] !== t2) {
    t3 = <h3 className="text-2xl font-bold">Liste des membres{" "}{t2}</h3>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isLoading) {
    t4 = isLoading && <ComponentLoading />;
    $[2] = isLoading;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <div className="flex flex-col m-4 gap-2 mb-1">{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = !isLoading && <div className="overflow-hidden"><EmblaCarousel options={{
      loop: true,
      duration: 30
    }}>{slides.map(_temp2)}</EmblaCarousel></div>;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <div className={t1}>{t5}{t6}</div>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
function _temp2(pagedMembers, index1) {
  return <div key={`memberSlide-${index1}`} className="flex flex-wrap flex-col md:flex-row mt-4">{pagedMembers.map(_temp)}</div>;
}
function _temp(member, index2) {
  return <div key={`memberSlideItem-${index2}`} className="flex flex-col w-full md:w-1/2 justify-between px-4 lg:even:pl-12 lg:odd:pr-12 mt-1"><Info member={member} hideWebsite={true} publicPage={true} /><div className="py-4"><p className="bg-light-grey  h-[2px] rounded-full w-full" /></div></div>;
}